import React, {useState} from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import {navigate} from 'gatsby';
import Arrow from '../../Components/Arrow';

function News(props) {
  const {news} = props;
  const [dragging, setDragging] = useState(false);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    adaptiveHeight: true,
    beforeChange: () => {
      setDragging(true);
    },
    afterChange: () => {
      setDragging(false);
    },
    nextArrow: <Arrow type="next" />,
    prevArrow: <Arrow type="prev" />,
  };
  return (
    <Wrapper>
      <div className="title">
        <div className="dots" />
        <h1>NEWS</h1>
        <div className="dots" />
      </div>
      <div style={{flexBasis: 30}} />
      <Slider {...settings}>
        {news.map((n, i) => (
          <div
            className="card"
            key={i}
            onClick={async () => {
              if (dragging) {
                return;
              }
              await navigate(`/article?id=${n.id}`);
            }}>
            <img src={n.image} alt="news" />
          </div>
        ))}
      </Slider>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: #aace2d;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 0;
  transition: all 400ms ease;
  & > .title {
    display: flex;
    align-items: center;
    margin: 0 auto;
    & > h1 {
      font-family: MavenPro, sans-serif;
      font-size: 60px;
      font-weight: 900;
      color: #ffeb00;
      text-align: center;
      margin: 0 50px;
    }
    & > .dots {
      width: 265px;
      border-top: 8px dotted #fff;
    }
  }

  & .card {
    width: 414px !important;
    height: 220px;
    background-color: #fff;
    border-radius: 20px;
    margin: 0 19px;
    cursor: pointer;
    transition: transform 400ms ease;
    &:hover {
      transform: scale(1.05);
    }
    & > img {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      object-fit: cover;
    }
  }

  @media screen and (max-width: 991px) {
    & > .title {
      & > h1 {
        font-size: 40px;
      }
      & > .dots {
        width: 100px;
      }
    }
  }

  @media screen and (max-width: 425px) {
    & > .title {
      & > h1 {
        font-size: 24px;
      }
      & > .dots {
        width: 30px;
      }
    }

    & .card {
      width: 220px !important;
      height: 116px;
      background-color: #fff;
      border-radius: 20px;
      margin: 0 19px;
    }
  }
`;

export default News;
